module.exports = __webpack_public_path__ + "img/LandingPage_VideoIntro.89d57cc5.png";